import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.INTERNAL_HELP_CENTER,
  permissions: ['administrator', 'agent'],
};

const internalHelpCenterRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/internal-articles'),
      name: 'internal_articles_index',
      meta,
      component: () =>
        import(
          'dashboard/components-next/InternalHelpCenter/Pages/InternalArticlesIndexPage.vue'
        ),
    },
    {
      path: frontendURL('accounts/:accountId/internal-articles/new'),
      name: 'internal_articles_new',
      meta,
      component: () =>
        import(
          'dashboard/components-next/InternalHelpCenter/Pages/InternalArticleEditorPage.vue'
        ),
    },
    {
      path: frontendURL('accounts/:accountId/internal-articles/:articleId'),
      name: 'internal_articles_show',
      meta,
      component: () =>
        import(
          'dashboard/components-next/InternalHelpCenter/Pages/InternalArticleShowPage.vue'
        ),
    },
    {
      path: frontendURL(
        'accounts/:accountId/internal-articles/:articleId/edit'
      ),
      name: 'internal_articles_edit',
      meta,
      component: () =>
        import(
          'dashboard/components-next/InternalHelpCenter/Pages/InternalArticleEditorPage.vue'
        ),
    },
  ],
};

export default internalHelpCenterRoutes;
